import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ApnInterface } from 'app/module/apn-interface';

@Injectable({
	providedIn: 'root'
})
export class ApnService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public get(): Observable<ApnInterface[]> {
		return this.http.get<ApnInterface[]>(`${this.url}apn`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}
}
